import type { Maybe } from '@adornis/base/utilTypes.js';
import { Float } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import { KPF } from '@chancenwerk/master-data-management/kpf/entities/KPF.js';

@Entity()
export class CapacityRequestOverview extends AdornisEntity {
  static override _class = 'CapacityRequestOverview';

  @Field(type => String)
  public KPFID: Maybe<string>;

  @DataLoadedField(type => KPF, ({ KPFID }) => KPFID)
  public kpf: Maybe<KPF>;

  @Field(type => Float)
  public leko: Maybe<number>;

  @Field(type => Float)
  public schuko: Maybe<number>;

  @Field(type => Boolean)
  public highPriority: Maybe<boolean>;

  @Field(type => Boolean, {
    resolve: function (this: CapacityRequestOverview) {
      return async () => {
        const col = await getRawCollection<{ _id: string; notification: boolean }>('capacity-request-meta');
        const doc = await col.findOne({ _id: this.KPFID });
        return doc?.notification ?? false;
      };
    },
  })
  public notification: Maybe<boolean>;
}
